// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bm-0";
export var orangeButton = "_bm-1";